import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=e66a1a14&scoped=true&"
import script from "./Facebook.vue?vue&type=script&lang=ts&"
export * from "./Facebook.vue?vue&type=script&lang=ts&"
import style0 from "./Facebook.vue?vue&type=style&index=0&id=e66a1a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66a1a14",
  null
  
)

export default component.exports